import GlobalBase from '../global-base';

class VatCalculator extends GlobalBase {

    docReady() {
        this.initVatCalculator()
    }

    /**
     * Initialize the vat calculator f
     */
    initVatCalculator() {
        const button = document.getElementById("vat-button");

        if ( button == null ) {
            return null;
        }
        button.addEventListener( 'click', ( _ ) => {
            const vat = parseFloat(document.getElementById('vat').value.toString().replace(',', '.'));
            const vatIncludesComma = document.getElementById('vat').value.toString().includes(',')

            const price = parseFloat(document.getElementById('price').value.toString().replace(',', '.'));
            const priceIncludesComma = document.getElementById('price').value.toString().includes(',')

            const type = document.querySelector('input[name="type"]:checked');
            const targetPriceWithVat = document.getElementById("target-price-with-vat");
            const targetPriceWithoutVat = document.getElementById("target-price-without-vat");
            const targetVat = document.getElementById("target-vat");
            const priceBlock = document.getElementById("price-block");
            const priceBlockAdd = document.getElementById("price-block-add");
            const priceBlockRemove = document.getElementById("price-block-remove");

            document.getElementById("vat-text").style.minWidth = document.getElementById("price-text").offsetWidth

            if ( type == null ) return null
            else if ( type.value == "add" ) {
                priceBlock.style.display = "block";
                priceBlockAdd.style.display = "flex";
                priceBlockRemove.style.display = "none";

                const priceWithVat = price * (1 + vat / 100);

                const roundedPrice = this.roundToTwoDecimalPlaces(priceWithVat).toFixed(2);
                const roundedVat = this.roundToTwoDecimalPlaces(roundedPrice - price).toFixed(2);

                targetPriceWithVat.innerText = priceIncludesComma || vatIncludesComma ? roundedPrice.toString().replace('.', ',') : roundedPrice;
                targetVat.innerText = priceIncludesComma || vatIncludesComma ? roundedVat.toString().replace('.', ',') : roundedVat;
                document.getElementById("vat-text").style.minWidth = document.getElementById("price-text").offsetWidth + 'px';

            } else if ( type.value == "remove" ) {
                priceBlock.style.display = "block";
                priceBlockRemove.style.display = "flex";
                priceBlockAdd.style.display = "none";

                const priceWithoutVat = price / (1 + ( vat / 100 ) );

                const roundedPrice = this.roundToTwoDecimalPlaces(priceWithoutVat).toFixed(2);
                const roundedVat = this.roundToTwoDecimalPlaces(price - roundedPrice).toFixed(2);

                targetPriceWithoutVat.innerText = priceIncludesComma || vatIncludesComma ? roundedPrice.toString().replace('.', ',') : roundedPrice;
                targetVat.innerText = priceIncludesComma || vatIncludesComma ? roundedVat.toString().replace('.', ',') : roundedVat;
                document.getElementById("vat-text").style.minWidth = document.getElementById("price-without-vat").offsetWidth + 'px';

            } else return null
        } );
    }

    roundToTwoDecimalPlaces(value) {
        return Math.round(value * 100) / 100    
    }
}

export default new VatCalculator();
